import React from 'react';
import {parseDateWithFormat} from '@shared/dateUtils';
import HistoryDate from '@di-shared/features/history/date/HistoryDate';

interface HistoryDatePageProps {
  vin: string;
  date: string;
}

export default function HistoryDatePage({vin, date}: HistoryDatePageProps) {
  const verifiedDate = parseDateWithFormat(date);

  if (!verifiedDate) {
    throw new Error('HistoryDate parse error');
  }

  return (
    <HistoryDate
      vin={vin}
      date={verifiedDate}
    />
  );
}
